import { useContext } from 'react';
import { SelectedProducerContext } from './selected-producer-provider';
import type { SelectedProducerContextValue } from './selected-producer-provider';
export function useSelectedProducer() {
  return useContext(SelectedProducerContext);
}